var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emd-form-group",class:[
        `_state_${_vm.state}`,
        {
            '_inline': _vm.inline,
        }
    ]},[(_vm.label)?_c('label',{staticClass:"emd-label",class:{'_required': _vm.required},attrs:{"data-testid":"form-group-label","for":_vm.labelFor}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._t("default"),_vm._l((_vm.activeFeedbacks),function(feedback){return _c('p',{key:feedback.msg,staticClass:"emd-input-feedback",attrs:{"data-cy":feedback.dataCy,"data-testid":"form-group-feedback"}},[_vm._v(" "+_vm._s(feedback.msg)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }